import {
  collection,
  query,
  where,
  getDocs,
  deleteDoc,
} from "firebase/firestore";
import { db } from "../firebase";

export async function deleteDocument(email) {
  const collectionRef = collection(db, "Users"); // 해당 컬렉션 참조 가져오기

  // 검색 조건에 따른 쿼리 생성 (예: 필드명이 'fieldName'이고 값이 'searchValue'인 문서 검색)
  const q = query(collectionRef, where("email", "==", email));

  try {
    const querySnapshot = await getDocs(q); // 쿼리 실행하여 검색된 문서 가져오기
    querySnapshot.forEach(async (doc) => {
      await deleteDoc(doc.ref); // 문서 삭제
      console.log("Document successfully deleted!");
    });
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
}
